module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAA0UlEQVQ4T5WSPQ7CMAyF/XwQRu4CW+LOsHEIflV+rwFibdqywFkYOQVLiVEQSAhaQTJFtj/7JX4gIirLsltV1YCZr977fZIkxxCvO8jzvEdEW1VFKACgqpqKSFoLZFl2AdD6TAKYW2tnX3HnnA+NGxQsRWTynoNzTpv0PiWurLXjV81P4Fm4FpHRo8GvCW/TNyIyjAECa6MAAIcoQFXjgFhJUY/+/1sBfC3uRkRct21mXhhjpp/WOBNR+2/zRds7dC6KouO974c7M++MMacmQ94BucRvMbCOZNkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 0